import styled from 'styled-components/macro'
import { BREAKPOINTS, ExternalLink } from 'theme'

const FooterWrapper = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 16px 40px 22px 51px;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.md}px) {
    flex-direction: column;
    justify-content: flex-end;
  }
`

const FooterText = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 13px;
  color: ${({ theme }) => theme.textSecondary};
`

export const Footer = () => {
  return (
    <FooterWrapper>
      <FooterText>© {new Date().getFullYear()} Ducatus. All rights reserved</FooterText>
      <FooterText>
        <ExternalLink href="mailto:swapsupport@mail.aaplusdex.com" style={{ textDecoration: 'none', color: 'inherit' }}>
          swapsupport@mail.aaplusdex.com
        </ExternalLink>
      </FooterText>
    </FooterWrapper>
  )
}
